import {
  handleChangeActionType,
  handleChangeAllActionType,
  handleChangeToInitStateActionType,
} from "../../actions/handleChangeAction";

const INITIAL_STATE = {
  kjennemerke: "",
  dato: "",
  tid: "",
  understellsnummer: "",
};

export default function innsynMotorvognFilterFormReducer(
  state = { ...INITIAL_STATE },
  action,
) {
  switch (action.type) {
    case handleChangeActionType("INNSYN_MOTORVOGN_FILTER_FORM"):
      return { ...state, [action.variableName]: action.payload };
    case handleChangeAllActionType("INNSYN_MOTORVOGN_FILTER_FORM"):
      return { ...state, ...action.payload };
    case handleChangeToInitStateActionType("INNSYN_MOTORVOGN_FILTER_FORM"):
      return { ...INITIAL_STATE };
    default:
      return state;
  }
}
